(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('VirtualNumber', VirtualNumber);

    VirtualNumber.$inject = ['$resource', 'DateUtils'];

    function VirtualNumber ($resource, DateUtils) {
        var resourceUrl =  'api/virtual-numbers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastActionTime = DateUtils.convertDateTimeFromServer(data.lastActionTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
